import React from "react";
import StatusBadge from "../../ui/StatusBadge";
import { useControlEffectivenessConfig } from "../../hooks/useControlEffectivenessConfig";
import {
  buildControlEffectivenessBadgeToken,
  getControlEffectivenessEntry,
} from "../../utils/controlEffectiveness";

export default function ControlEffectivenessBadge({ value, config, ...rest }) {
  const { items } = useControlEffectivenessConfig({ enabled: !config });
  const resolvedConfig = config || items;
  const entry = getControlEffectivenessEntry(resolvedConfig, value);

  return (
    <StatusBadge
      variant="status"
      value={entry.value}
      label={entry.label}
      fallbackLabel={entry.label}
      customToken={buildControlEffectivenessBadgeToken(entry)}
      {...rest}
    />
  );
}
